import { RecurrenceWhen } from '../../../../types'

/**
 * This function creates a unique ID for a recurrence when object.
 * it will recreate the object structure to ensure the ID is consistent, by using the same order of properties.
 * @param recurrenceWhen - The recurrence when object containing type and relevant properties.
 * @returns id of the recurrence when
 */
export function createRecurrenceWhenId(recurrenceWhen: RecurrenceWhen): string {
  switch (recurrenceWhen.type) {
    case 'WEEKLY': {
      return JSON.stringify({
        type: recurrenceWhen.type,
        weekday: recurrenceWhen.weekday,
      })
    }

    case 'MONTHLY': {
      return JSON.stringify({
        type: recurrenceWhen.type,
        date: recurrenceWhen.date,
        weekday: recurrenceWhen.weekday,
        cardinal: recurrenceWhen.cardinal,
      })
    }

    case 'ANNUALLY': {
      return JSON.stringify({
        type: recurrenceWhen.type,
        date: recurrenceWhen.date,
        month: recurrenceWhen.month,
        weekday: recurrenceWhen.weekday,
        cardinal: recurrenceWhen.cardinal,
      })
    }
  }
}
